<div class="implants-list--container">
    <div class="table-container">


        <div *ngIf="isTransitStocks" class="transit-list-wrapper">
            <!-- Title and Record Summary Header -->
            <div class="title-summary-header mb-3">
                <h2 class="text-heading-3 text-start mb-1 text-capitalize">Transit Stock</h2>
                <div class="record-summary-header" *ngIf="isFilterResult || (isSearch && searchResults.length > 0)">
                    <span class="text-para text-light-dark">
                        <span *ngIf="isSearch && searchResults.length > 0">
                            {{ searchResults.length }} search results
                        </span>
                        <span *ngIf="!isSearch && isFilterResult">
                            {{ (currentPage - 1) * pageSize + 1 }}-{{ Math.min(currentPage * pageSize, totalRecords) }} of {{ totalRecords }} records
                        </span>
                    </span>
                    <span class="text-para text-light-dark ms-3">
                        <span *ngIf="isSearch && searchResults.length > 0">{{ searchResults.length }} shipments</span>
                        <span *ngIf="!isSearch && isFilterResult">{{ totalRecords }} shipments</span>
                    </span>
                </div>
            </div>
            
            <!-- Sort and Filter Controls -->
            <div class="list-controls mb-3">
                                 <div class="controls-left">
                     <div class="search-controls">
                         <form action="" class="search-block" (submit)="onSearchSubmit()">
                             <div class="search-input">
                                 <input type="text" name="search" [(ngModel)]="searchInput" placeholder="Search by Shipment ID">
                             </div>
                             <button type="submit" class="icon-btn">
                                 <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                     <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                                 </svg>
                             </button>
                         </form>
                                         <button type="button" class="reset-btn" (click)="reset($event)">
                    Reset
                </button>
                     </div>
                 </div>
                <div class="controls-right">
                    <div class="sort-controls">
                        <button class="sort-btn" (click)="shippedAtSort()" [class.active]="shippedAtSortValue">
                            <i class="sort-icon" [ngClass]="shippedAtSortValue === 'desc' ? 'sort-desc' : 'sort-asc'"></i>
                            Shipped Date
                        </button>
                        <button class="sort-btn" (click)="deliveredAtSort()" [class.active]="deliveredAtSortValue">
                            <i class="sort-icon" [ngClass]="deliveredAtSortValue === 'desc' ? 'sort-desc' : 'sort-asc'"></i>
                            Delivered Date
                        </button>
                    </div>
                                         <div class="status-filter">
                         <button class="filter-trigger" (click)="openStatusPopup($event)">
                             <i class="filter-icon"></i>
                             Status Filter
                             <span *ngIf="selectedStatus.length > 0" class="filter-count">{{ selectedStatus.length }}</span>
                         </button>
                         <div class="popup" id="status-popup">
                             <form>
                                 <div class="form-group">
                                   <input name="status" id="in_transit" type="checkbox" value="0" [checked]="selectedStatus.includes('0') ? true : false" (change)="onStatusFilterChange($event)">
                                   <label for="in_transit">In Transit</label>
                                 </div>
                                 <div class="form-group">
                                   <input name="status" id="completed" type="checkbox" value="1" [checked]="selectedStatus.includes('1') ? true : false" (change)="onStatusFilterChange($event)">
                                   <label for="completed">Completed</label>
                                 </div>
                             </form>
                         </div>
                     </div>
                     <div class="export-filter">
                         <button class="export-trigger">
                             <i class="export-icon"></i>
                             Export
                         </button>
                     </div>

                </div>
            </div>

                                                   <!-- Search Results Table -->
                          <div class="search-table" *ngIf="isSearch && searchResults.length > 0">
                              <div class="table-header">
                                  <div class="header-cell">Shipment ID</div>
                                  <div class="header-cell">Shipped to</div>
                                  <div class="header-cell">Quantity</div>
                                  <div class="header-cell">Shipped Date</div>
                                  <div class="header-cell">Delivered Date</div>
                                  <div class="header-cell">Status</div>
                              </div>
                              
                              <div class="table-row" *ngFor="let stock of searchResults; let i = index" (click)="navigateToDetailPage(stock.shipment_id)" [ngClass]="{'alternate-row': i % 2 === 1}">
                                  <div class="table-cell shipment-id">{{ stock.shipment_id }}</div>
                                  <div class="table-cell">{{ stock.shipped_to }}</div>
                                  <div class="table-cell">{{ stock.quantity }}</div>
                                  <div class="table-cell">{{ stock.shipped_at ? timestampFormat(stock.shipped_at,"DD/MM/YYYY") : '-' }}</div>
                                  <div class="table-cell">{{ stock.delivered_at ? timestampFormat(stock.delivered_at,"DD/MM/YYYY") : '-' }}</div>
                                  <div class="table-cell">
                                      <span class="status-badge" [ngClass]="stock.is_transit === 'Completed' ? 'status-completed' : 'status-transit'">
                                          {{ stock.is_transit }}
                                      </span>
                                  </div>
                              </div>
                          </div>

                          <!-- Transit List Table -->
                          <div class="transit-table" *ngIf="isFilterResult && !isSearch">
                              <div class="table-header">
                                  <div class="header-cell">Shipment ID</div>
                                  <div class="header-cell">Shipped to</div>
                                  <div class="header-cell">Quantity</div>
                                  <div class="header-cell">Shipped Date</div>
                                  <div class="header-cell">Delivered Date</div>
                                  <div class="header-cell">Status</div>
                              </div>
                              
                              <div class="table-row" *ngFor="let stock of transitStocks; let i = index" (click)="navigateToDetailPage(stock.shipment_id)" [ngClass]="{'alternate-row': i % 2 === 1}">
                                  <div class="table-cell shipment-id">{{ stock.shipment_id }}</div>
                                  <div class="table-cell">{{ stock.shipped_to }}</div>
                                  <div class="table-cell">{{ stock.quantity }}</div>
                                  <div class="table-cell">{{ stock.shipped_at ? timestampFormat(stock.shipped_at,"DD/MM/YYYY") : '-' }}</div>
                                  <div class="table-cell">{{ stock.delivered_at ? timestampFormat(stock.delivered_at,"DD/MM/YYYY") : '-' }}</div>
                                  <div class="table-cell">
                                      <span class="status-badge" [ngClass]="stock.is_transit === 'Completed' ? 'status-completed' : 'status-transit'">
                                          {{ stock.is_transit }}
                                      </span>
                                  </div>
                              </div>
                          </div>

                                                   <!-- No Results -->
                          <div *ngIf="!isFilterResult && !isSearch" class="no-results">
                              <div class="no-results-content">
                                  <img src="../../../../assets/images/table/filter_empty_screen.svg" alt="" srcset="">
                                  <h2 class="header-2 mb-2">No records were found matching your search</h2>
                                  <p class="text-para text-light-dark">Try adjusting your search criteria or filters</p>
                              </div>
                          </div>
                          
                          <!-- No Search Results -->
                          <div *ngIf="isSearch && searchResults.length === 0" class="no-results">
                              <div class="no-results-content">
                                  <img src="../../../../assets/images/table/filter_empty_screen.svg" alt="" srcset="">
                                  <h2 class="header-2 mb-2">No search results found</h2>
                                  <p class="text-para text-light-dark">Try adjusting your search criteria</p>
                              </div>
                          </div>
             

         </div>
 
         <div class="" *ngIf="totalPages > 1 && isTransitStocks">
             <app-pagination [totalPages]="totalPages" (queryPage)="getQueryPage($event)"></app-pagination>
         </div>
    </div>
    <div *ngIf="!isTransitStocks" class="p-3 m-3 text-center flex-container flex-column justify-content-center">
        <img src="../../../../assets/images/table/empty_cabinet_summary.svg" alt="" srcset="">
        <h2 class="header-2 mb-2">No records available to view</h2>
    </div>
</div>

